// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_1hq0yE"};